import Vue from "vue";
import Router from "vue-router";
import { api } from "@/state/services";

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: "/",
  routes: [
    {
      path: "/",
      component: () => import("./views/home"),
      meta: { authRequired: true, sponsored: 'any' },
    },
    {
      path: "/login",
      component: () => import("./views/login"),
      meta: { authRequired: false, sponsored: 'any' },
    },
    {
      path: "/login/token/:token",
      component: () => import("./views/login-in"),
      meta: { authRequired: false, sponsored: 'any' },
    },
    {
      path: "/logout",
      redirect: "/login",
    },
    {
      path: "/register",
      component: () => import("./views/register"),
      meta: { authRequired: false, sponsored: 'any' },
    },
    {
      path: "/register/:sponsor",
      component: () => import("./views/register"),
      meta: { authRequired: false, sponsored: 'any' },
    },
    {
      path: "/register/:sponsor/:plan",
      component: () => import("./views/register"),
      meta: { authRequired: false, sponsored: 'any' },
    },
    {
      path: "/password-forgot",
      component: () => import("./views/password-forgot"),
      meta: { authRequired: false, sponsored: 'any' },
    },
    {
      path: "/password-change",
      component: () => import("./views/password-change"),
      meta: { authRequired: false, sponsored: 'any' },
    },
    {
      path: "/account",
      component: () => import("./views/account/account"),
      meta: { authRequired: true, sponsored: 'any' },
    },
    {
      path: "/account/indication",
      component: () => import("./views/account/indication"),
      meta: { authRequired: true },
    },
    {
      path: "/account/documents",
      component: () => import("./views/account/documents"),
      meta: { authRequired: true, sponsored: 'any' },
    },
    {
      path: "/account/address",
      component: () => import("./views/account/address"),
      meta: { authRequired: true, sponsored: 'any' },
    },
    {
      path: "/account/password",
      component: () => import("./views/account/password"),
      meta: { authRequired: true, sponsored: 'any' },
    },
    {
      path: "/account/password/security",
      component: () => import("./views/account/password-security"),
      meta: { authRequired: true, sponsored: 'any' },
    },
    {
      path: "/account/password/security/:token",
      component: () => import("./views/account/password-security"),
      meta: { authRequired: true, sponsored: 'any' },
    },
    {
      path: "/account/pix",
      component: () => import("./views/account/pix"),
      meta: { authRequired: true, sponsored: 'any' },
    },
    {
      path: "/contracts",
      component: () => import("./views/contracts/list"),
      meta: { authRequired: true, sponsored: 'any' },
    },
    {
      path: "/contracts/:id",
      component: () => import("./views/contracts/view"),
      meta: { authRequired: true, sponsored: 'any' },
    },
    {
      path: "/wallet/weekly/extract",
      component: () => import("./views/wallet/weekly-extract"),
      meta: { authRequired: true, sponsored: 'any' },
    },
    {
      path: "/wallet/weekly/transfer",
      component: () => import("./views/wallet/weekly-transfer"),
      meta: { authRequired: true, sponsored: 'any' },
    },
    {
      path: "/wallet/weekly/pay",
      component: () => import("./views/wallet/weekly-pay"),
      meta: { authRequired: true, sponsored: 'any' },
    },
    {
      path: "/wallet/weekly/pay/:id",
      component: () => import("./views/wallet/weekly-pay"),
      meta: { authRequired: true, sponsored: 'any' },
    },
    {
      path: "/wallet/weekly/withdrawal",
      component: () => import("./views/wallet/weekly-withdrawal"),
      meta: { authRequired: true, sponsored: 'any' },
    },
    {
      path: "/wallet/weekly/withdrawal/history",
      component: () => import("./views/wallet/weekly-withdrawal-history"),
      meta: { authRequired: true, sponsored: 'any' },
    },
    {
      path: "/wallet/monthly/extract",
      component: () => import("./views/wallet/monthly-extract"),
      meta: { authRequired: true, sponsored: 'any' },
    },
    {
      path: "/wallet/monthly/transfer",
      component: () => import("./views/wallet/monthly-transfer"),
      meta: { authRequired: true, sponsored: 'any' },
    },
    {
      path: "/wallet/monthly/pay",
      component: () => import("./views/wallet/monthly-pay"),
      meta: { authRequired: true, sponsored: 'any' },
    },
    {
      path: "/wallet/monthly/pay/:id",
      component: () => import("./views/wallet/monthly-pay"),
      meta: { authRequired: true, sponsored: 'any' },
    },
    {
      path: "/wallet/monthly/withdrawal",
      component: () => import("./views/wallet/monthly-withdrawal"),
      meta: { authRequired: true, sponsored: 'any' },
    },
    {
      path: "/wallet/monthly/withdrawal/history",
      component: () => import("./views/wallet/monthly-withdrawal-history"),
      meta: { authRequired: true, sponsored: 'any' },
    },
    {
      path: "/wallet/special/extract",
      component: () => import("./views/wallet/special-extract"),
      meta: { authRequired: true, sponsored: 'any' },
    },
    {
      path: "/wallet/special/pay",
      component: () => import("./views/wallet/special-pay"),
      meta: { authRequired: true, sponsored: 'any' },
    },
    {
      path: "/wallet/special/pay/:id",
      component: () => import("./views/wallet/special-pay"),
      meta: { authRequired: true, sponsored: 'any' },
    },
    {
      path: "/network/clients",
      component: () => import("./views/network/clients"),
      meta: { authRequired: true, sponsored: 'any' },
    },
    {
      path: "/network/sponsored",
      component: () => import("./views/network/sponsored"),
      meta: { authRequired: true, sponsored: 'any' },
    },
    {
      path: "/network/team",
      component: () => import("./views/network/team"),
      meta: { authRequired: true, sponsored: 'any' },
    },
    {
      path: "/network/matriz",
      component: () => import("./views/network/matriz"),
      meta: { authRequired: true, sponsored: 'any' },
    },
    {
      path: "/network/unilevel",
      component: () => import("./views/network/unilevel"),
      meta: { authRequired: true, sponsored: 'any' },
    },
    {
      path: "/network/unilevel/:id",
      component: () => import("./views/network/unilevel"),
      meta: { authRequired: true, sponsored: 'any' },
    },
    {
      path: "/reports/indicacao",
      component: () => import("./views/reports/indicacao"),
      meta: { authRequired: true, sponsored: 'any' },
    },
    {
      path: "/reports/assinatura",
      component: () => import("./views/reports/assinatura"),
      meta: { authRequired: true, sponsored: 'any' },
    },
    {
      path: "/reports/locacaointeligente",
      component: () => import("./views/reports/locacaointeligente"),
      meta: { authRequired: true, sponsored: 'any' },
    },
    {
      path: "/reports/recorrencia",
      component: () => import("./views/reports/recorrencia"),
      meta: { authRequired: true, sponsored: 'any' },
    },
    {
      path: "/reports/graduation",
      component: () => import("./views/reports/graduation"),
      meta: { authRequired: true, sponsored: 'any' },
    },
    {
      path: "/store",
      redirect: "/store/featured",
    },
    {
      path: "/store/featured",
      component: () => import("./views/store/featured"),
      meta: { authRequired: true, sponsored: 'any' },
    },
    {
      path: "/store/category/:id",
      component: () => import("./views/store/category"),
      meta: { authRequired: true, sponsored: 'any' },
    },
    {
      path: "/store/search",
      component: () => import("./views/store/search"),
      meta: { authRequired: true, sponsored: 'any' },
    },
    {
      path: "/store/cart",
      component: () => import("./views/store/cart"),
      meta: { authRequired: true, sponsored: 'any' },
    },
    {
      path: "/store/orders",
      component: () => import("./views/store/orders"),
      meta: { authRequired: true, sponsored: 'any' },
    },
    {
      path: "/store/order/:id",
      component: () => import("./views/store/order"),
      meta: { authRequired: true, sponsored: 'any' },
    },
    {
      path: "/downloads",
      component: () => import("./views/downloads"),
      meta: { authRequired: true, sponsored: 'any' },
    },
    {
      path: "/faq",
      component: () => import("./views/faq"),
      meta: { authRequired: true, sponsored: 'any' },
    },
    {
      path: "/tickets",
      component: () => import("./views/tickets"),
      meta: { authRequired: true, sponsored: 'any' },
    },
    {
      path: "/tickets/:id",
      component: () => import("./views/tickets-view"),
      meta: { authRequired: true, sponsored: 'any' },
    },
    {
      path: "/courses",
      component: () => import("./views/courses/list"),
      meta: { authRequired: true, sponsored: 'any' },
    },
    {
      path: "/courses/:course",
      component: () => import("./views/courses/view"),
      meta: { authRequired: true, sponsored: 'any' },
    },
    {
      path: "/courses/:course/:module/:lesson",
      component: () => import("./views/courses/view"),
      meta: { authRequired: true, sponsored: 'any' },
    },
    {
      path: "/informatives",
      component: () => import("./views/informatives/index"),
      meta: { authRequired: true },
    },
    {
      path: "/informatives/:id",
      component: () => import("./views/informatives/view"),
      meta: { authRequired: true },
    },
    {
      path: "/events",
      component: () => import("./views/events/index"),
      meta: { authRequired: true, sponsored: 'any' },
    },
    {
      path: "/events/orders",
      component: () => import("./views/events/orders-list"),
      meta: { authRequired: true, sponsored: 'any' },
    },
    {
      path: "/events/orders/:id",
      component: () => import("./views/events/orders-view"),
      meta: { authRequired: true, sponsored: 'any' },
    },
    {
      path: "/events/tickets",
      component: () => import("./views/events/tickets"),
      meta: { authRequired: true, sponsored: 'any' },
    },
    {
      path: "/events/:id",
      component: () => import("./views/events/view"),
      meta: { authRequired: true, sponsored: 'any' },
    },
    {
      path: "/packages",
      component: () => import("./views/_packages/index"),
      meta: { authRequired: true, sponsored: 'any' },
    },
    {
      path: "/packages/buy",
      component: () => import("./views/_packages/buy"),
      meta: { authRequired: true, sponsored: 'any' },
    },
    {
      path: "/packages/vouchers",
      component: () => import("./views/_packages/vouchers"),
      meta: { authRequired: true, sponsored: 'any' },
    },
    {
      path: "/packages/cartao",
      component: () => import("./views/_packages/cartao"),
      meta: { authRequired: true, sponsored: 'any' },
    },
    {
      path: "/packages/:id",
      component: () => import("./views/_packages/order"),
      meta: { authRequired: true, sponsored: 'any' },
    },
    {
      path: "/trackers",
      component: () => import("./views/_trackers/index"),
      meta: { authRequired: true, sponsored: 'any' },
    },
    {
      path: "/trackers/add",
      component: () => import("./views/_trackers/add"),
      meta: { authRequired: true, sponsored: 'any' },
    },
    {
      path: "/trackers/:id",
      component: () => import("./views/_trackers/view"),
      meta: { authRequired: true, sponsored: 'any' },
    },
    {
      path: "/vehicles",
      component: () => import("./views/_vehicles/index"),
      meta: { authRequired: true, sponsored: 'any' },
    },
    {
      path: "/vehicles/inspections/:id",
      component: () => import("./views/_vehicles/inspections-view"),
      meta: { authRequired: true, sponsored: 'any' },
    },
    {
      path: "/vehicles/:id",
      component: () => import("./views/_vehicles/view"),
      meta: { authRequired: true, sponsored: 'any' },
    },
    {
      path: "/pagamentos",
      component: () => import("./views/_pagamentos/index"),
      meta: { authRequired: true, sponsored: 'any' },
    },
    {
      path: "/descontos",
      component: () => import("./views/_descontos/index"),
      meta: { authRequired: true, sponsored: 'any' },
    },
    {
      path: "/descontos/:id",
      component: () => import("./views/_descontos/view"),
      meta: { authRequired: true, sponsored: 'any' },
    },
    {
      path: "/404",
      component: () => import("./views/404"),
      meta: { authRequired: false, sponsored: 'any' },
    },
    {
      path: "/:sponsor",
      redirect: "/register/:sponsor",
    },
    {
      path: "/:sponsor/:plan",
      redirect: "/register/:sponsor/:plan",
    },
  ],
});

router.beforeEach((to, from, next) => {
  const loggedIn = localStorage.getItem("token");

  document.title = process.env.VUE_APP_TITLE
  next();

  if (to.meta.authRequired && !loggedIn) {
    return next("/login");
  }

  if (to.meta.authRequired && loggedIn) {
    api
      .get("user")
      .then((response) => {
        if (response.data && response.data.status == "success") {
          router.app.$store.state.account.user = response.data.user;

          if (
            response.data.user.contracts &&
            response.data.user.contracts.length > 0 &&
            to.path != "/contracts/" + response.data.user.contracts[0].id
          ) {
            response.data.user.contracts.forEach(con => {
              return next("/contracts/" + con.id);
            })
          } else if (
            response.data.user.package &&
            response.data.user.package.status == "inactive" &&
            !to.path.startsWith("/packages")) {
            return next("/packages/buy");
          }
        } else {
          return next("/login");
        }
      })
      .catch(error => {
        if (error) {
          return next("/login");
        }
      });
  } else {
    next();
  }
});

export default router;
